

import { useEffect, useState } from 'react'

import { parseViewer } from './useParseViewer'

import { setCookie, useHttpRequest } from './httpRequest'
import useCallBack, { Callbacks } from './callback/useCallBack'
import { tokenKey } from '../global'



export const AppQuery = <T>( callbacks?: Callbacks<T>) => {
    const { onError, onLoading, onSuccess } = useCallBack<any>(callbacks)

    const { getRequest } = useHttpRequest({
        
    })
    const getViewer = async () => {
        try {
            const response = await getRequest(`Auth/SilentLoginV1`)
            const data = await response
            return data
        } catch (error) {
            onError(error as Error)
        }
    }

        ; (async function () {
            try {
                const res = await getViewer()
                if (res) {
                    if (res.succeeded) onSuccess(res)
                    else onError({ name: '', message: res.message })
                }
            } catch (error) {
                onError(error as Error)
            } finally {
                onLoading(false)
            }
        })()
}

const useMatterSuiteAppQuery = (...dependency: any) => {
    const [preferences, localization, company, location] = dependency
    const [viewer, setViewer] = useState<any | undefined>(undefined)
    const [wizardPosition, setWizardPosition] = useState(null)
    const [registrationData, setRegistrationData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    

    useEffect(() => {
        AppQuery<Response>( {
            onSuccess: (response: any) => {
                const viewer = parseViewer(response?.data?.viewer!)
                const authToken = viewer.companies?.[0]?.userRoles?.role?.[0]?.authToken! ?? viewer.companies?.[0]?.locations?.[0]?.userRoles?.role?.[0]?.authToken!
                const refreshToken = viewer?.refreshToken! ?? ''
                setCookie(tokenKey, authToken!)
                setCookie('refreshToken', refreshToken)
                setViewer(viewer)
                setWizardPosition(response?.data?.wizardPosition!)
                setRegistrationData(response?.data?.registrationData!)
            },
            onLoading: (loading) => setLoading(loading),
            onError: (error: any) => setError(error),
        })
    }, [localization, preferences,  company, location])

    return { viewer, wizardPosition, registrationData, loading, error }
}

export default useMatterSuiteAppQuery
